import { type QuizQuestionText } from '@efdigital/ll-addon-data';
import Component from '@glimmer/component';

import type { QuizQuestionResponseEditorComponentSignature } from '../../types/question-manager';
import CollapsibleResponse from './shared/collapsible-response.gts';

export class TextResponseEditorComponent extends Component<QuizQuestionResponseEditorComponentSignature> {
  get questionData(): QuizQuestionText {
    return this.args.question.text!;
  }

  <template>
    <div class="card-body p-0">
      <div class="form-label p-3">Configure feedback based on whether the user
        provides an answer:</div>

      <CollapsibleResponse
        @label="Feedback if answered"
        @response={{this.questionData.response}}
      />

      <CollapsibleResponse
        @label="Feedback if blank"
        @response={{this.questionData.response0}}
      />
    </div>
  </template>
}
